module.exports = __webpack_public_path__ + "img/Cepat@3x.29e9172d.png";